import BikeModel from "./BikeModel";

export default BikeModel;
